import { HandUnderline } from '@/components/brand/HandUnderline'
import { CloseConsole } from '@/components/home/CloseConsole'
import { GlassPanel } from '@/components/sections/GlassPanel'
import { BookCallButton, ButtonLink } from '@/components/ui/Button'
import { sitePages } from '@/config/pages'

export const HomeHero = () => (
  <GlassPanel className="hero" shade="hero" labelledBy="hero-title">
    <div className="nav-space" aria-hidden="true" />
    <div className="hero-body">
      <div className="hero-copy">
        <h1 id="hero-title" className="display">
          The future of accounting is <HandUnderline>Human</HandUnderline>
        </h1>
        <p className="hero-lead">
          United invests in accounting firms, bringing the capital to grow and the technology to change how the work gets done.
        </p>
        <div className="actions">
          <ButtonLink to={sitePages.howItWorks.path} variant="ink">
            Learn how it works
          </ButtonLink>
          <BookCallButton />
        </div>
      </div>
      <CloseConsole />
    </div>
  </GlassPanel>
)
